const candidate = {
  light: {
    // Base Colors
    active: 'purple accent-4',
    cancel: 'muted',
    danger: 'error',
    error: 'error',
    input: 'deep-orange',
    link: 'primary--text',
    loading: 'success',
    muted: 'grey',
    primary: 'primary',
    primaryContrast: 'deep-orange lighten-3',
    secondary: 'grey lighten-3',
    success: 'success',
    warning: 'warning',

    // Text Colors
    errorText: 'error--text',
    inputText: 'primary--text',
    mutedText: 'muted--text',
    primaryText: 'primary--text',
    secondaryText: 'grey--text text--lighten-3',
    successText: 'success--text',
    warningText: 'warning--text',

    // Component Colors
    cardSubtitle: 'muted--text',
    cardTitle: 'black--text',
    chip: 'grey darken-1 white--text',
    dangerButton: 'error white--text',
    dialogTitle: 'grey darken-3 white--text',
    footer: 'grey darken-3 white--text',
    highlightTooltip: 'grey darken-3',
    primaryActionButton: 'primary white--text',
    secondaryActionButton: 'grey lighten-3 black--text',
    successButton: 'success white--text',
    tooltip: 'grey darken-2',
    badge: 'grey darken-3',
  },
  dark: {
    // Base Colors
    active: 'purple accent-4',
    cancel: 'grey',
    danger: 'red',
    error: 'red',
    input: 'orange lighten-2',
    primary: 'blue darken-1',
    success: 'success',
    warning: 'orange lighten-2',
    // Text Colors
    accentText: 'orange--text text--lighten-1',
    activeText: 'purple--text text--accent-4',
    primaryText: 'blue--text text--darken-4',
    secondaryText: 'blue--text',
    successText: 'success--text',
    mutedText: 'grey--text',
    onColourText: 'grey--text text--lighten-2',
    // Component Colors
    cardTitle: 'white--text',
    cardSubtitle: 'grey--text',
    chip: 'grey darken-1 white--text',
    dialogTitle: 'deep-purple darken-2 white--text',
    link: 'orange--text text--lighten-2',
    primaryActionButton: 'deep-purple darken-2',
    secondaryActionButton: 'blue darken-1',
    tooltip: 'grey darken-2',
    highlightTooltip: 'grey darken-3',
  },
}

const client = {
  light: {
    // Base Colors
    cancel: 'grey',
    danger: 'red darken-1',
    error: 'red darken-1',
    input: 'deep-orange',
    link: 'deep-orange--text text--darken-2',
    muted: 'grey',
    primary: 'grey darken-3',
    secondary: 'grey lighten-3',
    success: 'green lighten-1',
    tertiary: 'grey darken-1',
    warning: 'orange lighten-2',

    // Text Colors
    cardSubtitleText: 'grey--text',
    cardTitleText: 'black--text',
    errorText: 'red--text text--darken-1',
    lowContrastText: 'grey--text grey--accent-4',
    inputText: 'deep-orange--text',
    mutedText: 'grey--text',
    successText: 'green--text',
    warningText: 'orange--text text--lighten-2',
    primaryText: 'grey--text text--darken-3',

    // Component Colors
    badge: 'grey darken-1 white--text',
    chip: 'grey lighten-2 black--text',
    dialogTitle: 'grey darken-3 white--text',
    highlightTooltip: 'grey darken-3',
    primaryActionButton: 'grey darken-3 white--text',
    secondaryActionButton: 'grey black--text',
    successButton: 'green lighten-1 white--text',
    errorButton: 'red darken-1 white--text',
    warningButton: 'orange white--text',
    toolbar: 'grey lighten-3',
    tooltip: 'grey darken-2',
  },

  dark: {
    // Base Colors
    cancel: 'grey lighten-1',
    input: 'deep-orange',

    // Component Colors
    chip: 'grey darken-1 white--text',
    primaryActionButton: 'deep-orange white--text',
  },
}

export default {
  candidate,
  client,
}
